import React from "react";

function CheckoutIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      fill="none"
      viewBox="0 0 22 22"
    >
      <rect
        width="22"
        height="22"
        fill="url(#paint0_linear_99_97)"
        rx="11"
      ></rect>
      <path
        fill="#212020"
        d="M9.998 14.844l-3.242-3.242a.519.519 0 010-.723l.703-.703a.495.495 0 01.703 0l2.207 2.187 4.688-4.687a.495.495 0 01.703 0l.703.703a.519.519 0 010 .723l-5.742 5.742a.519.519 0 01-.723 0z"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_99_97"
          x1="3.497"
          x2="29.995"
          y1="31.605"
          y2="21.957"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.5" stopColor="#ADFF00"></stop>
          <stop offset="0.8" stopColor="#CF0"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
}

export default CheckoutIcon;
